import React, { useState } from 'react'
import BigModal from '../../../../../components/Modals/BigModal'
import {
  Alert,
  Button,
  ButtonGroup,
  Divider,
  Grid,
  Stack,
  Typography,
} from '@mui/material'
import AnDateTimePicker from '../../../../../components/DateTime/DateTimePicker'
import moment from 'moment'

const CSpine = ({ open, onClose, submitModule }) => {
  const [moduleValues, setModuleValues] = useState({
    dateTime: moment(),
  })
  return (
    <BigModal open={open} onClose={onClose}>
      <Grid container spacing={2} alignItems="center">
        <Grid item xs={12} lg={6}>
          <Typography variant="title2">C-Spine Assessment</Typography>
        </Grid>
        <Grid item xs={12} lg={6}>
          <AnDateTimePicker
            date={moduleValues.dateTime}
            fullWidth
            size="small"
            onChange={(newDate) =>
              setModuleValues((prev) => ({ ...prev, dateTime: newDate }))
            }
          />
        </Grid>
      </Grid>

      <Stack gap={3} divider={<Divider />}>
        <Stack>
          <Typography>
            Age {'≥'}65 years, extremity paresthesias, or dangerous mechanism
          </Typography>
          <Typography variant="caption">
            Fall from ≥3 ft (0.9 m) / 5 stairs, axial load injury, high speed
            MVC/rollover/ejection, bicycle collision, motorized recreational
            vehicle
          </Typography>
          <ButtonGroup fullWidth>
            <Button
              color="error"
              variant={
                moduleValues?.['High Risk Features'] === 'Yes'
                  ? 'contained'
                  : 'outlined'
              }
              onClick={() =>
                setModuleValues((prev) => ({
                  ...prev,
                  ['High Risk Features']: 'Yes',
                }))
              }
            >
              Yes
            </Button>
            <Button
              color="success"
              variant={
                moduleValues?.['High Risk Features'] === 'No'
                  ? 'contained'
                  : 'outlined'
              }
              onClick={() =>
                setModuleValues((prev) => ({
                  ...prev,
                  ['High Risk Features']: 'No',
                }))
              }
            >
              No
            </Button>
          </ButtonGroup>
        </Stack>
        {moduleValues?.['High Risk Features'] === 'No' && (
          <Stack>
            <Typography>Ambulatory since the incident</Typography>
            <ButtonGroup fullWidth>
              <Button
                color="success"
                variant={
                  moduleValues?.['Ambulatory since the incident'] === 'Yes'
                    ? 'contained'
                    : 'outlined'
                }
                onClick={() =>
                  setModuleValues((prev) => ({
                    ...prev,
                    ['Ambulatory since the incident']: 'Yes',
                  }))
                }
              >
                Yes
              </Button>
              <Button
                color="error"
                variant={
                  moduleValues?.['Ambulatory since the incident'] === 'No'
                    ? 'contained'
                    : 'outlined'
                }
                onClick={() =>
                  setModuleValues((prev) => ({
                    ...prev,
                    ['Ambulatory since the incident']: 'No',
                  }))
                }
              >
                No
              </Button>
            </ButtonGroup>
          </Stack>
        )}

        {moduleValues?.['Ambulatory since the incident'] === 'Yes' && (
          <Stack>
            <Typography>Delayed (not immediate) onset</Typography>
            <ButtonGroup fullWidth>
              <Button
                color="success"
                variant={
                  moduleValues?.['Delayed Onset'] === 'Yes'
                    ? 'contained'
                    : 'outlined'
                }
                onClick={() =>
                  setModuleValues((prev) => ({
                    ...prev,
                    ['Delayed Onset']: 'Yes',
                  }))
                }
              >
                Yes
              </Button>
              <Button
                color="error"
                variant={
                  moduleValues?.['Delayed Onset'] === 'No'
                    ? 'contained'
                    : 'outlined'
                }
                onClick={() =>
                  setModuleValues((prev) => ({
                    ...prev,
                    ['Delayed Onset']: 'No',
                  }))
                }
              >
                No
              </Button>
            </ButtonGroup>
          </Stack>
        )}
        {moduleValues?.['Delayed Onset'] === 'Yes' && (
          <Stack>
            <Typography>Midline Tenderness</Typography>
            <ButtonGroup fullWidth>
              <Button
                color="error"
                variant={
                  moduleValues?.['Midline Tenderness'] === 'Yes'
                    ? 'contained'
                    : 'outlined'
                }
                onClick={() =>
                  setModuleValues((prev) => ({
                    ...prev,
                    ['Midline Tenderness']: 'Yes',
                  }))
                }
              >
                Yes
              </Button>
              <Button
                color="success"
                variant={
                  moduleValues?.['Midline Tenderness'] === 'No'
                    ? 'contained'
                    : 'outlined'
                }
                onClick={() =>
                  setModuleValues((prev) => ({
                    ...prev,
                    ['Midline Tenderness']: 'No',
                  }))
                }
              >
                No
              </Button>
            </ButtonGroup>
          </Stack>
        )}
        {moduleValues?.['Midline Tenderness'] === 'No' && (
          <Stack>
            <Typography>
              Able to actively rotate neck 45° left and right
            </Typography>
            <ButtonGroup fullWidth>
              <Button
                color="success"
                variant={
                  moduleValues?.['Able to rotate neck'] === 'Yes'
                    ? 'contained'
                    : 'outlined'
                }
                onClick={() =>
                  setModuleValues((prev) => ({
                    ...prev,
                    ['Able to rotate neck']: 'Yes',
                  }))
                }
              >
                Yes
              </Button>
              <Button
                color="success"
                variant={
                  moduleValues?.['Able to rotate neck'] === 'No'
                    ? 'contained'
                    : 'outlined'
                }
                onClick={() =>
                  setModuleValues((prev) => ({
                    ...prev,
                    ['Able to rotate neck']: 'No',
                  }))
                }
              >
                No
              </Button>
            </ButtonGroup>
          </Stack>
        )}

        {moduleValues?.['High Risk Features'] === 'Yes' ||
          moduleValues?.['Ambulatory since the incident'] === 'No' ||
          moduleValues?.['Delayed Onset'] === 'No' ||
          moduleValues?.['Midline Tenderness'] === 'Yes' ||
          moduleValues?.['Able to rotate neck'] === 'No' ? (
          <Stack gap={1}>
            <Alert severity="error">
              High Risk! C-Spine cannot be cleared clinically using these
              criteria. Immobilisation is recommended.
            </Alert>
            <Button
              onClick={() => submitModule('C-Spine', moduleValues)}
              variant="contained"
              fullWidth
              color="success"
            >
              Submit
            </Button>
          </Stack>
        ) : moduleValues?.['High Risk Features'] === 'No' &&
          moduleValues?.['Ambulatory since the incident'] === 'Yes' &&
          moduleValues?.['Delayed Onset'] === 'Yes' &&
          moduleValues?.['Midline Tenderness'] === 'No' &&
          moduleValues?.['Able to rotate neck'] === 'Yes' ? (
          <Stack gap={1}>
            <Alert severity="success">
              Low Risk! C-Spine can be cleared clinically using these criteria
              according to <i>The Canadian C-spine Rule</i>.
            </Alert>
            <Button
              onClick={() => submitModule('C-Spine', moduleValues)}
              variant="contained"
              fullWidth
              color="success"
            >
              Submit
            </Button>
          </Stack>
        ) : (
          <Button
            onClick={() => onClose()}
            variant="outlined"
            fullWidth
            color="error"
          >
            Cancel
          </Button>
        )}
      </Stack>
    </BigModal>
  )
}

export default CSpine
